module.exports = __webpack_public_path__ + "static/media/2.796497f9.svg";